// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2nTai","footerInner":"style_footerInner__3Cd1Q","logo":"style_logo__wn50a"};